import type { ConfluenceUpdatePageCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';

import type {
	ConfluencePageUpdateCommandProcessor,
	ConfluencePageUpdateCommandProcessorWithPartialStreaming,
} from '../stream-processors/command-processors';

import { type PassThroughCommandProperties } from './types/command-handler-types';
import { StreamingCommandHandler } from './types/streaming-command-handler';

export class UpdateCommandHandler extends StreamingCommandHandler<ConfluenceUpdatePageCommandProperties> {
	constructor(
		properties: PassThroughCommandProperties,
		private updateCommandProcessor:
			| ConfluencePageUpdateCommandProcessor
			| ConfluencePageUpdateCommandProcessorWithPartialStreaming,
	) {
		super(properties, 'update');
	}

	async process(params: ConfluenceUpdatePageCommandProperties): Promise<void> {
		await this.updateCommandProcessor.streamChunk(params.data.toolCalls, params.isStreamComplete);
	}

	async finish(): Promise<void> {
		await this.updateCommandProcessor.finish();
	}

	abort(): void {
		this.updateCommandProcessor.abort();
	}
}
